import { render, staticRenderFns } from "./NavigationNotificationIconParts.vue?vue&type=template&id=3a90427d"
import script from "./NavigationNotificationIconParts.vue?vue&type=script&lang=ts"
export * from "./NavigationNotificationIconParts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports